import { Injectable } from "@angular/core";
import { PlessDialogServiceSub } from "src/app/commons/kymw00/pless-dialog-service-sub";
import { PlessJsonResponderSub } from "src/app/commons/kymw00/pless-json-responder-sub.service";
import { PlessHttp } from "src/app/shared/http/pless-http.service";
import { PlessRequest } from "src/app/shared/vo/pless-request.model";
import { MasterInputModel } from "../../kymw6901-master-input-tab/vo/master-input.model";
import { KYMW6901ProposalTabModel } from "../kymw6901-proposal-tab.model";
import { NewGoodsProposalModel } from "../vo/new-goods-proposal.model";
import { KYMW6901Component } from "../../kymw6901.component";
import { PlessViewUtilsSub } from "src/app/commons/kymw00/pless-view-utils-sub.service";

type GetExistingGoodsCopyResponse = {
  JanCode: string;
  GoodsName: string;
  StandardName: string;
  ClassCode: string;
  LargeClassCode: string;
  MiddleClassCode: string;
  SmallClassCode: string;
  OrderUnitType: string;
  SetQuantity: string;
  SuggestedPriceSellingNormal: string;
  SuggestedPriceSellingSpecial1: string;
  SuggestedPriceSellingSpecial2: string;
  SuggestedPricePurchaseNormal: string;
  SuggestedPricePurchaseSpecial1: string;
  SuggestedPricePurchaseSpecial2: string;
  BundlePrice: string;
  UnitPriceDiv: string;
  UnitPriceCoefficient: string;
  UnitPriceUnit: string;
  EdlpDiv: string;
  ConsumeByDate: string;
  ConsumeTerm: string;
  SetDiv: string;
  CaseSupplyDiv: string;
  ArrivalAreaDiv: string;
  ArrivalGoodsTemp: string;
  ArrivalAdminDays: string;
  BrandType: string;
  EcologyDiv: string[];
  CycleTerm: string;
  PriceType: string;
  MakerPrice: string;
  CoopCodeList: string[];
  GoodsExplanation: string;
  Catchphrase: string;
  RecommendComment: string;
  UsefulInfoEnclosure: string;
  UsefulInfoConfiguration: string;
  UsefulInfoOther: string;
  UsefulInfoSize: string;
  HandlingCaution: string;
  ConsumeTaxRate: string;
  LiquorCode: string;
  AlcoholType: string;
  ContainerForm: string;
  ApplyTermStart: string;
  ApplyTermEnd: string;
  SeasonConsumeDiv: string;
  SeasonConsumeTermStart: string;
  SeasonConsumeTermEnd: string;
  StinkGoodsDiv: string;
  ListingGoodsName: string;
  ListingType: string;
  ListingContentsQuantity: string;
  ListingSize: string;
  ListingSizeCm: string;
  ListingNumber: string;
  ListingColor: string;
  RelationPcodeOld: string;
  SpecialOrderType: string;
  StockType: string;
  PdPilingUpDays: string;
  FactoryAddress1: string;
  FactoryAddress2: string;
  FcmcFee: string;
  GuideTempZoneDiv: string;
  MakerName: string;
};

/**
 * 既存商品情報を取得するサービス
 *
 * @export GetExistingGoodsCopyService
 * @class GetExistingGoodsCopyService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetExistingGoodsCopyService extends PlessJsonResponderSub<GetExistingGoodsCopyResponse> {
  private model: KYMW6901ProposalTabModel;
  private successFunc: (ClassCode : string) => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub,
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetExistingGoodsCopyService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        PCode: this.model.existingGoods.pCode,
        ItemCode: this.model.existingGoods.itemCode,
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetExistingGoodsCopyService
   */
  execute(model: KYMW6901ProposalTabModel, successFunc?: (ClassCode : string) => void): void {
    this.model = model;

    this.successFunc = successFunc;
    this.send('getExistingGoodsCopy', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetExistingGoodsCopyService
   */
  success(data: GetExistingGoodsCopyResponse): void {
    const result = data;
    this.model.newGoodsProposal = new NewGoodsProposalModel(
      '',
      '',
      result.ClassCode,
      '',
      result.GoodsName,
      result.StandardName,
      result.JanCode,
      '',
      result.SuggestedPriceSellingNormal,
      result.SuggestedPriceSellingSpecial1,
      result.SuggestedPriceSellingSpecial2,
      result.SuggestedPricePurchaseNormal,
      result.SuggestedPricePurchaseSpecial1,
      result.SuggestedPricePurchaseSpecial2,
      KYMW6901ProposalTabModel.calcGpr(result.SuggestedPriceSellingNormal, result.SuggestedPricePurchaseNormal),
      KYMW6901ProposalTabModel.calcGpr(result.SuggestedPriceSellingSpecial1, result.SuggestedPricePurchaseSpecial1),
      KYMW6901ProposalTabModel.calcGpr(result.SuggestedPriceSellingSpecial2, result.SuggestedPricePurchaseSpecial2),
      result.ConsumeByDate,
      result.ConsumeTerm,
      '',
      '',
      '',
      '',
      this.model.toCoopMap(result.CoopCodeList),
      '',
      '',
      '',
      false,
      false,
      result.GuideTempZoneDiv,
      '',
      result.MakerName,
      '',
      '',
      '',
      false,
      '',
      '',
      '',
      '',
      '',
      ''
    );

    const masterInput = new MasterInputModel(
      '',
      '',
      '',
      '',
      result.JanCode,
      result.GoodsName,
      result.StandardName,
      '',
      result.ClassCode,
      result.LargeClassCode,
      result.MiddleClassCode,
      result.SmallClassCode,
      result.OrderUnitType,
      result.SetQuantity,
      result.SuggestedPriceSellingNormal,
      result.SuggestedPriceSellingSpecial1,
      result.SuggestedPriceSellingSpecial2,
      result.SuggestedPricePurchaseNormal,
      result.SuggestedPricePurchaseSpecial1,
      result.SuggestedPricePurchaseSpecial2,
      result.BundlePrice,
      result.UnitPriceDiv,
      result.UnitPriceCoefficient,
      result.UnitPriceUnit,
      result.EdlpDiv,
      result.ConsumeByDate,
      result.ConsumeTerm,
      result.SetDiv,
      result.CaseSupplyDiv,
      result.ArrivalAreaDiv,
      result.ArrivalGoodsTemp,
      result.ArrivalAdminDays,
      result.BrandType,
      result.EcologyDiv,
      result.CycleTerm,
      result.PriceType,
      result.MakerPrice,
      this.model.toCoopMap(result.CoopCodeList),
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      result.GoodsExplanation,
      result.Catchphrase,
      result.RecommendComment,
      result.UsefulInfoEnclosure,
      result.UsefulInfoConfiguration,
      result.UsefulInfoOther,
      result.UsefulInfoSize,
      result.HandlingCaution,
      {
        markDiv1: '',
        markDiv2: '',
        markDiv3: '',
        markDiv4: '',
        markDiv5: '',
        markDiv6: '',
        markDiv7: '',
        markDiv8: '',
        markDiv9: '',
        markDiv10: ''
      },
      result.ConsumeTaxRate,
      '',
      '',
      '',
      '',
      '',
      result.LiquorCode,
      result.AlcoholType,
      result.ContainerForm,
      PlessViewUtilsSub.editDate(result.ApplyTermStart, '2'),
      PlessViewUtilsSub.editDate(result.ApplyTermEnd, '2'),
      result.SeasonConsumeDiv === '1' ? true: false,
      PlessViewUtilsSub.editDate(result.SeasonConsumeTermStart, '4'),
      PlessViewUtilsSub.editDate(result.SeasonConsumeTermEnd, '4'),
      result.StinkGoodsDiv,
      result.ListingGoodsName,
      result.ListingType,
      result.ListingContentsQuantity,
      result.ListingSize,
      result.ListingSizeCm,
      result.ListingNumber,
      result.ListingColor,
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      result.RelationPcodeOld,
      result.SpecialOrderType,
      result.StockType,
      result.PdPilingUpDays,
      result.FactoryAddress1,
      result.FactoryAddress2,
      result.FcmcFee
    );
    this.model.parent.sendMasterInput(masterInput);

    if (this.successFunc) {
      this.successFunc(result.ClassCode);
    }
  }
}
